import EditCollectionForm from './EditCollectionForm';

export default EditCollectionForm;



// WEBPACK FOOTER //
// ./src/scenes/Collections/components/EditCollectionForm/index.ts